// App
import environment from '../../app/lib/environment.app';

export default `Sally/George/${environment()}`;
